import { Injectable } from '@angular/core';
import { ApiV1_Category, ApiV1_Product } from '@pedix-workspace/api-v1';
import { getAllScoredSearchEntries, searchInIndexWithScores } from '@pedix-workspace/utils';
import { combineLatest, map, Observable } from 'rxjs';
import {
  createScoredSearchCatalogIndex,
  ScoredSearchCatalogIndex,
  SearchCatalogIndexOptions,
} from '../utils/search-catalog-index';

@Injectable({ providedIn: 'root' })
export abstract class SearchResultsService {
  private searchIndex: ScoredSearchCatalogIndex | null;

  abstract getCategories(): Observable<ApiV1_Category[]>;
  abstract getProducts(): Observable<ApiV1_Product[]>;

  invalidateIndex() {
    this.searchIndex = null;
  }

  getSearchResults(
    searchTerm: string,
    options: SearchCatalogIndexOptions,
  ): Observable<ApiV1_Product[]> {
    return combineLatest([this.getCategories(), this.getProducts()]).pipe(
      map(([categories = [], products = []]) => {
        if (!this.searchIndex) {
          this.searchIndex = createScoredSearchCatalogIndex(categories, products, options);
        }
        if (!searchTerm) {
          return getAllScoredSearchEntries(this.searchIndex);
        }

        return searchInIndexWithScores(this.searchIndex, searchTerm).map(result => result.entry);
      }),
    );
  }

  getFilteredResults(products: ApiV1_Product[], filters: { productTagIds?: string[] } = {}) {
    if (!filters.productTagIds || filters.productTagIds.length === 0) {
      return products;
    }
    return products.filter(product => {
      if (product.linkedProductTagIds) {
        return product.linkedProductTagIds.some(tagId => filters.productTagIds?.includes(tagId));
      } else {
        return true;
      }
    });
  }
}
